import { render, staticRenderFns } from "./Sampling.vue?vue&type=template&id=10b73f3d&scoped=true&"
import script from "./Sampling.vue?vue&type=script&lang=js&"
export * from "./Sampling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b73f3d",
  null
  
)

export default component.exports